(function () {
    'use strict';

    angular
        .module('invesfleet')
        .factory('reportService', reportService);

    reportService.$inject = ['$http', '$q', 'endPoints', 'authorization', '$window', '$filter', 'preferences'];

    function reportService($http, $q, endPoints, authorization, $window, $filter, preferences) {

        var service = {
            listReports : listReports,
            ReportsTAX: { list: [], default: null},
            ReportsLOG: { list: [], default: null},
            ReportsGRU: { list: [], default: null},
            getAvailableReports : getAvailableReports,
            genericReport: genericReport,
            downloadReport: downloadReport,
			downloadHojaDeRuta: downloadHojaDeRuta,
			customQuery: customQuery,
        };

        return service;

        function getAvailableReports(){
            getReports('GRU');
            getReports('TAX');
            getReports('LOG');
        }

        function listReports(tipoOrden){
            if(tipoOrden == null) { tipoOrden = 0; }

            if(preferences.prefs.sector === 'TAX'){
                return service.ReportsTAX;
            } else {
                if(tipoOrden === 0) { return service.ReportsGRU; }
                else { return service.ReportsLOG; }
            }
        }

        function getReports(sectorId){
            var name = 'GetReportListGru';
            if(sectorId === 'TAX') { name = 'GetReportListTax'; }
            else if(sectorId === 'LOG') { name = 'GetReportListLog'; }

            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.report.getReport + name
            };
            
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                
                if(sectorId === 'TAX') { service.ReportsTAX.list = response.data; }
                else if(sectorId === 'LOG') { service.ReportsLOG.list = response.data; }
                else { service.ReportsGRU.list = response.data; }

                var pred = $filter('filter')(response.data, 
                    function(value, index, array){ 
                        if(value.predeterminado === true){ 
                            return true;
                        } else {
                            return false;
                        } 
                    })[0];
                if(pred == null){
                    pred = response.data[0];
                }

                if(sectorId === 'TAX') { service.ReportsTAX.default = pred; }
                else if(sectorId === 'LOG') { service.ReportsLOG.default = pred; }
                else { service.ReportsGRU.default = pred; }

                deferred.resolve(response.data);
            },
            function (response) {
                deferred.reject(null);
            });
            return deferred.promise;
        }

        function downloadHojaDeRuta(ordenId){
            downloadReport(ordenId, '/INVESFLEET/NuevosFormatos/Formatos/HojasDeRuta/rpt_HojaRuta_TAX');
        }

        function downloadReport(ordenId, reportUrl) {
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                responseType: 'arraybuffer',
                url: endPoints.report.getReport + 'DownloadReport' + '?urlName=' + reportUrl + '&orderId=' + ordenId
			};
			var myWindow = window.open();
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                var file = new Blob([response.data], {type: 'application/pdf'});
                var fileURL = URL.createObjectURL(file);
				myWindow.location.href = fileURL;
                deferred.resolve(response.data);
            },
            function (response) {
				//myWindow.close();
				myWindow.document.write('<h1>Ha habido un error al abrir el informe</h1>');
                deferred.reject(null);
            });
            return deferred.promise;
		}

		function genericReport(miData) {
			var deferred = $q.defer();
			var request = {
				method: 'POST',
				responseType: 'arraybuffer',
				url: endPoints.report.getReport + 'GenericReport' + '?urlName=' + miData.url,
				data: miData.datosPeticion
			};
			authorization.setBearerHeader($http);
			$http(request).then(function (response) {
				var file = new Blob([response.data], { type: 'application/pdf' });
				var fileURL = URL.createObjectURL(file);

				//$window.open(fileURL);
				//show in Iframe
				var iframe = document.createElement('iframe');
				iframe.className = 'sample-iframe';
				iframe.src = fileURL;

				var myNodeIframe = document.getElementById('iFrameResult');
				while (myNodeIframe.firstChild) {
					myNodeIframe.removeChild(myNodeIframe.firstChild);
				}
				myNodeIframe.appendChild(iframe);

				deferred.resolve(response.data);
			},
				function (response) {
					deferred.reject(null);
				});
			return deferred.promise;
		}


		function customQuery(miData) {
			var deferred = $q.defer();
			var request = {
				method: 'POST',
				url: endPoints.report.getReport + 'CustomQuery',
				data: miData.datosPeticion
			};
			authorization.setBearerHeader($http);
			$http(request).then(function (response) {
				deferred.resolve(response.data);
			},
				function (response) {
					deferred.reject(null);
				});
			return deferred.promise;
		}
    }
})();